import React from 'react'
import { find, set, noop } from 'lodash'
import { connect } from 'react-redux'

import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import api from '../../api'
import Fields from './fields'
import attachFiles from './attach-files'
import { setSnackbarMessage } from '../../actions/snackbar'

const styles = {
  cancelButton: {
    marginLeft: '15px'
  }
}

class Create extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      resource: {
        block_type: null,
        block_content: { }
      },
      files: {}
    }
  }

  render () {
    const type = this.state.resource.block_type
    const blockType = type ? find(this.props.blockTypes, { type }) : null

    return (
      <div>
        <form onSubmit={this.handleSubmit.bind(this)}>
          <div>
            <SelectField
              floatingLabelText='Block Type'
              value={this.state.resource.block_type}
              onChange={this.handleBlockTypeChange.bind(this)}
            >
              {this.props.blockTypes.map(({ type }) => {
                return <MenuItem key={type} value={type} primaryText={type} />
              })}
            </SelectField>

            {blockType && (
              <Fields
                fields={blockType.fields}
                schema={blockType.schema}
                content={this.state.resource.block_content}
                files={this.state.files}
                handleValueChange={this.handleBlockContentValueChange.bind(this)}
                handleFileChange={this.handleBlockContentFileChange.bind(this)}
              />
            )}
          </div>

          <RaisedButton
            label='Save'
            disabled={this.state.submitting}
            primary
            onClick={this.handleSubmit.bind(this)}
          />

          <RaisedButton
            label='Cancel'
            onClick={this.handleCancel.bind(this)}
            style={styles.cancelButton}
          />
        </form>
        <Dialog
          title='Error'
          modal={false}
          open={!!this.state.error}
          actions={[
            <FlatButton
              label='OK'
              primary
              onClick={this.handleAcknowledgeErrorMessage.bind(this)}
            />
          ]}
          onRequestClose={this.handleAcknowledgeErrorMessage.bind(this)}
        >
          {this.state.error}
        </Dialog>
      </div>
    )
  }

  handleSubmit (e) {
    e.preventDefault()

    if (this.state.submitting) {
      return
    }

    this.setState({ submitting: true })

    const body = {
      [this.props.cmsPageProp]: this.props.cmsPageId,
      ...this.state.resource
    }

    api.post(`admin/${this.props.target}`, { body })
      .then(res => {
        if (res.status === 201) {
          res.json()
            .then(this.attachFiles.bind(this))
            .then(data => {
              this.props.setSnackbarMessage(`Successfully created #${data.id}`)
              this.props.onBlockCreated(data)
              this.setState({ submitting: false })
            })
        } else if (res.status === 400) {
          res.json()
            .then(data => {
              this.setState({ error: data.message })
              this.props.setSnackbarMessage('Block could not be created')
              this.setState({ submitting: false })
            })
        } else {
          res.json()
            .then(data => {
              this.setState({ error: data.message })
              this.props.setSnackbarMessage('Unhandled error')
              this.setState({ submitting: false })
            })
        }
      })
  }

  attachFiles (pageBlock) {
    if (Object.keys(this.state.files).length === 0) {
      return Promise.resolve(pageBlock)
    }

    return attachFiles(pageBlock, this.props.target, this.state.files)
  }

  handleBlockTypeChange (e, index, value) {
    this.setState(prevState => {
      return {
        ...prevState,
        resource: {
          ...prevState.resource,
          block_type: value
        }
      }
    })
  }

  handleBlockContentValueChange (field, value) {
    this.props.onDirty()
    this.setState(prevState => {
      const blockContent = {
        ...prevState.resource.block_content,
        [field.prop]: value
      }

      return {
        ...prevState,
        resource: {
          ...prevState.resource,
          block_content: blockContent
        }
      }
    })
  }

  handleBlockContentFileChange (propPath, formData, file) {
    this.props.onDirty()
    this.setState(prevState => {
      const files = { ...prevState.files }
      set(files, propPath, { formData, file })
      return { ...prevState, files }
    })
  }

  handleCancel (e) {
    e.preventDefault()
    this.props.onCancel()
  }

  handleAcknowledgeErrorMessage () {
    this.setState({ error: null })
  }
}

// @ts-ignore
Create.propTypes = {
  cmsPageProp: React.PropTypes.string.isRequired,
  cmsPageId: React.PropTypes.string.isRequired,
  target: React.PropTypes.string.isRequired,
  blockTypes: React.PropTypes.arrayOf(React.PropTypes.object),
  onCancel: React.PropTypes.func.isRequired,
  onBlockCreated: React.PropTypes.func.isRequired,
  setSnackbarMessage: React.PropTypes.func.isRequired,
  onDirty: React.PropTypes.func
}

// @ts-ignore
Create.defaultProps = {
  onDirty: noop
}

export default connect(null, { setSnackbarMessage })(Create as any) as React.ComponentType<any>
